import 'css-chunksrc/client/pages/projectPage/timeSheetPage/allocations/allocation/recordList/record/styles.scss';export default {
  "record": "_record_dzue0_1",
  "input": "_input_dzue0_9",
  "resource": "_resource_dzue0_20",
  "list": "_list_dzue0_24",
  "clickable": "_clickable_dzue0_28"
};